module.exports = __webpack_public_path__ + "media/V79.9012b2bb.mp4";